import React, { Component } from "react";
import PropTypes from "prop-types";

export default class ModalLauncher extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    text: PropTypes.string,
    buttonClass: PropTypes.string,
    buttonIcon: PropTypes.string,
    link: PropTypes.bool
  };

  static defaultProps = {
    text: " Add",
    buttonClass: "btn-info",
    buttonIcon: "fa-plus",
    disabled: false
  };

  state = {
    open: false
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  open = () => this.setState({ open: true });

  close = () => {
    if (this.mounted) {
      this.setState({ open: false });
    }
  };

  button() {
    const { disabled, modal, buttonClass, buttonIcon, text } = this.props;
    return (
      <button
        onClick={this.open}
        disabled={disabled}
        className={`btn ${buttonClass}`}
        type="button"
      >
        <i className={`fa fa-fw ${buttonIcon}`} />
        {text}
        {modal(this.state.open, this.close, this.props)}
      </button>
    );
  }

  link() {
    const { modal, text } = this.props;
    return (
      <span onClick={this.open}>
        {text}
        {modal(this.state.open, this.close, this.props)}
      </span>
    );
  }

  render() {
    if (this.props.link) {
      return this.link();
    }

    return this.button();
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/ModalLauncher.jsx